import { render, staticRenderFns } from "./RestaurantIndex.vue?vue&type=template&id=7f4dc84d&scoped=true&"
import script from "./RestaurantIndex.vue?vue&type=script&lang=js&"
export * from "./RestaurantIndex.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantIndex.vue?vue&type=style&index=0&id=7f4dc84d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4dc84d",
  null
  
)

export default component.exports